import { styled } from '@mui/material/styles';
import Icon from 'components/v1/Icon';

export const StyledSmallIcon = styled(Icon)({
  width: '16px',
  height: '16px',
  marginRight: '10px',
  color: '#205077',
});
